import * as React from "react";
import Axios from "axios";
import moment from "moment";
import { NavLink } from "react-router-dom";
import {
  FormControlLabel,
  Grid,
  Button,
  IconButton,
  Box,
  Paper,
  Card,
  CardContent,
  CardHeader,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Divider from "@mui/material/Divider";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { blue, red } from "@mui/material/colors";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

import Layout from "../Layout/Layout";
import { seesionCheck } from "../Layout/function";

import "./AccountTable.css";

async function getCallData() {
  try {
    let result = await Axios.get(
      process.env.REACT_APP_BACKEND_DOMAIN_API + "/cms_user/all_list",
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem("accessToken"),
        },
      }
    );
    return result.data.data;
  } catch (error) {
    console.log(`bigc-online-catalogs: ${error}`);
  }
}

const MatchEdit = ({ index }) => {
  return (
    <FormControlLabel
      control={
        <NavLink to={`/cms-account/edit/${index}`}>
          <EditIcon style={{ color: blue[500] }} />
        </NavLink>
      }
    />
  );
};

const columns = [
  {
    field: "actions",
    headerName: "#",
    sortable: false,
    filterable: false,
    hideable: false,
    width: 50,
    disableClickEventBubbling: false,
    headerAlign: "center",
    renderCell: (params) => {
      return (
        <div className="ml-1 d-flex justify-content-between align-items-center dg-edit-icon">
          <MatchEdit index={params.row.id} />
        </div>
      );
    },
  },
  { field: "id", headerName: "ID", width: 100 },
  { field: "first_name", headerName: "First Name", width: 350 },
  { field: "last_name", headerName: "Last Name", width: 350 },
  { field: "email", headerName: "Email", width: 200 },
  { field: "status", headerName: "Status", width: 130 },
];

export default function DataTable() {
  const [users, setUsers] = React.useState([]);

  React.useEffect(async () => {
    await seesionCheck();
    const getUsers = await getCallData();
    setUsers(getUsers);
  }, []);

  if (users.length > 0) {
    users.map((val) => {
      val.updatedAt = moment(val.updatedAt).format("YYYY-MM-DD hh:mm:ss");
      val.status = (val.status===1)?'Active': 'Inactive';
    });
  }

  return (
    <Layout>
      <Paper sx={{ height: 900, width: "100%", mb: 10 }}>
        <Card>
          <CardHeader title="Account" />
        </Card>
        <Box sx={{ pt: 3, mb: 2 }}>
          <NavLink to={`/cms-account/add`}>
            <Button color="primary" variant="outlined" sx={{ ml: 2 }}>
              <AddIcon style={{ color: blue[500] }} /> Add New
            </Button>
          </NavLink>
        </Box>

        <DataGrid
          sx={{ height: 700 }}
          rows={users}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
        />
      </Paper>
    </Layout>
  );
}
